/**
 * @file store mutations
 * @author wangzhongpeng
 */

 export default {
  SET_REGIONLIST(state, arr) {
    state.rawRegionList = arr;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_PERMISSION(state, permission) {
    //permission 为传入的权限标识集合
    // 传入的权限集合 赋值给状态中的 permission
    state.buttonPermissionList = permission;
  }
};
